<!-- Единый контейнер секции настроек прав: заголовок, пояснения и содержимое. -->
<template>
  <section
    class="permission-settings-section"
    :class="{
      'permission-settings-section--without-icon': !icon,
    }"
  >
    <AppIcon
      v-if="icon?.type === 'app_icon'"
      class="permission-settings-section__icon"
      :name="icon.value"
      :size="16"
    />
    <span
      v-else-if="icon?.type === 'emoji'"
      class="permission-settings-section__icon permission-settings-section__emoji"
    >
      {{ icon.value }}
    </span>

    <div class="permission-settings-section__heading">
      <div class="permission-settings-section__title-row">
        <span class="permission-settings-section__title">
          {{ title }}
        </span>
        <BaseInfoTooltip v-if="helpText" :text="helpText" />
      </div>
    </div>

    <p
      v-if="description"
      class="permission-settings-section__description"
    >
      {{ description }}
    </p>

    <div class="permission-settings-section__content">
      <slot />
    </div>
  </section>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "PermissionRoleSettingsSection",

  components: { AppIcon },

  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    helpText: {
      type: String,
      default: "",
    },
    icon: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped>
.permission-settings-section {
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr);
  column-gap: 7px;
  row-gap: 8px;
  width: min(560px, 100%);
  padding: 12px 0 0;
  border-top: 1px solid #edf0f3;
  color: #475569;
  font-size: 14px;
}

.permission-settings-section--without-icon {
  grid-template-columns: minmax(0, 1fr);
}

.permission-settings-section__icon {
  grid-column: 1;
  grid-row: 1;
  margin-top: 2px;
}

.permission-settings-section__emoji {
  line-height: 1;
}

.permission-settings-section__heading {
  grid-column: 2;
  min-width: 0;
}

.permission-settings-section--without-icon
  .permission-settings-section__heading {
  grid-column: 1;
}

.permission-settings-section__title-row {
  display: flex;
  align-items: center;
  gap: 7px;
}

.permission-settings-section__title {
  font-weight: 500;
}

.permission-settings-section__description {
  grid-column: 1 / -1;
  margin: 0;
  color: #64748b;
  font-size: 13px;
  line-height: 1.45;
}

.permission-settings-section__content {
  grid-column: 1 / -1;
  min-width: 0;
}
</style>
